import React from 'react';
import PropTypes from 'prop-types';
import { GroupProvider } from '../../../contexts/GroupContext';

export const SingleContentPageConditionalWrapper = ({
    render,
    group,
    PAGE_PROPS,
    userRelation,
}) => {
    if (group) {
        return (
            <GroupProvider
                PAGE_PROPS={PAGE_PROPS}
                userRelation={userRelation}
                group={group}
            >
                {render()}
            </GroupProvider>
        );
    }
    return render();
};

SingleContentPageConditionalWrapper.propTypes = {
    PAGE_PROPS: PropTypes.shape({}),
    group: PropTypes.shape({}),
    userRelation: PropTypes.shape({}),
    render: PropTypes.func,
};
